module.exports = __webpack_public_path__ + "img/home-bg-dark.2c3702b1.jpg";